module.exports = __webpack_public_path__ + "img/button1.93690225.png";